import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, Note } from '@card-software/library';
import { SupplyRequest, SupplyRequestSearchCommand } from '../../models/supply-request/supply-request';

@Injectable({
  providedIn: 'root',
})
export class SupplyRequestProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/supply-request';

  public getById(id: string): Observable<ApiResponse<SupplyRequest>> {
    return this.httpClient.get<ApiResponse<SupplyRequest>>(`${this.baseUrl}/${id}`);
  }

  public create(body: SupplyRequest): Observable<ApiResponse<SupplyRequest>> {
    return this.httpClient.post<ApiResponse<SupplyRequest>>(this.baseUrl, body);
  }

  public update(id: string, body: SupplyRequest): Observable<ApiResponse<SupplyRequest>> {
    return this.httpClient.put<ApiResponse<SupplyRequest>>(`${this.baseUrl}/${id}`, body);
  }

  public delete(id: string): Observable<ApiResponse<SupplyRequest>> {
    return this.httpClient.delete<ApiResponse<SupplyRequest>>(`${this.baseUrl}/${id}`);
  }

  public updateStatus(id: string, status: number): Observable<ApiResponse<SupplyRequest>> {
    const body = {
      status: status,
    };
    return this.httpClient.patch<ApiResponse<SupplyRequest>>(`${this.baseUrl}/${id}/status`, body);
  }

  public search(command: SupplyRequestSearchCommand): Observable<ApiResponse<SupplyRequest[]>> {
    return this.httpClient.post<ApiResponse<SupplyRequest[]>>(`${this.baseUrl}/search`, command);
  }

  public insertNote(id: string, note: Note): Observable<ApiResponse<object>> {
    return this.httpClient.patch<ApiResponse<object>>(`${this.baseUrl}/${id}/note`, note);
  }
}
